/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".resultSet{font-size:100%;font-family:inherit;color:inherit;background-color:transparent;margin:5px;padding:5px;border-color:transparent;border-radius:3px;width:99%;display:block;text-align:left}.resultSet:hover{cursor:pointer!important;background-color:#f8f8f8}.resultSet:focus{background-color:#d3d3d3}.displayName{font-weight:700}.result-container{max-height:200px;overflow:auto}"];
export { styles as styles };
